import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useNavigate } from 'react-router-dom';

import classnames from "classnames";

// core components
import Navbar from "../layouts/Navbar.js";

import '../../assets/css/Login.css'

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function Register() {
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  //const [roleCheck, setRoleCheck] = useState('');
  const [userId, setUserId] = useState('');

  useEffect(() => {

    //로딩중 표기
    setIsLoading(true);

    // 프로필 정보 불러오기
    let profileRequest;

    //get-session 이후 실행(1초)
    const timeout = setTimeout(() => {

      async function getUserInfo() {
        profileRequest = await axios.get(
        `/profile/getUserInfo`,
        { baseURL : process.env.REACT_APP_SERVER_URL },
        {
          withCredentials: true
        })
        .then((response) => {

          setIsLoading(false);

          profileRequest = response.data;

          if (profileRequest.success) {
            const userInfoData = profileRequest.userInfo;

            // DB에서 불러온 사용자 정보 세팅
            setFormData({
              email: userInfoData.email,
              password: '',
              passwordCheck: '',
              name: userInfoData.name,
              cellphone: formatPhoneNumber(userInfoData.cellphone),
              role: userInfoData.role,
            });

            //setRoleCheck(userInfoData.role)
            setUserId(userInfoData.email);

          } else {
            const errorMessage  = profileRequest.messages;
            // alert("errors : " + JSON.stringify(errorMessage.errors));
            if (errorMessage && errorMessage.databaseError) {
              setErrorMessage({ errors : errorMessage.databaseError });
            }
          }
        })
        .catch((error) => {
          console.error('로그인 상태 확인 실패:', error);
        });
      }

      getUserInfo();

    }, 100); // 시간을 밀리초 단위로 설정 (1초 = 1000 밀리초)

    // Mouse Action
    document.documentElement.addEventListener("mousemove", followCursor);
    // Specify how to clean up after this effect:
    return function cleanup() {
      document.documentElement.removeEventListener("mousemove", followCursor);
      clearTimeout(timeout);
    };

  }, []);

  const [squares1to6, setSquares1to6] = useState("");
  const [squares7and8, setSquares7and8] = useState("");

  const [fullNameFocus, setFullNameFocus] = useState(false);
  const [cellPhoneFocus, setCellPhoneFocus] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);
  const [passwordFocus, setPasswordFocus] = useState(false);

  const [passwordErrors, setPasswordErrors] = useState({});

  const [errorMessage, setErrorMessage] = useState({});

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    passwordCheck: '',
    name: '',
    cellphone: '',
    role: ''
  });

  // 전화번호 입력 시에 000-0000-0000과 같은 형태로 표기
  const formatPhoneNumber = (val) => {
    const number = val.trim().replace(/[^0-9]/g, "");

    if (number.length < 4) return number;
    if (number.length < 7) return number.replace(/(\d{3})(\d{1})/, "$1-$2");
    if (number.length < 11) return number.replace(/(\d{3})(\d{3})(\d{1})/, "$1-$2-$3");
    return number.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // 입력되는 값이 전화번호 일 때
    if (name ==='cellphone'){
      const number = formatPhoneNumber(value);
      setFormData({"cellphone": number});
    }
  };

  //암호를 두 번 입력하여 검증
  const validatePassword = () => {
    const passwordCheckInputIcon = document.getElementById('passwordCheckIcon');
    const passwordCheckInputBorder = document.getElementById('passwordCheckBorder');

    // "password"와 "passwordCheck" 필드에 대한 유효성 검사를 수행합니다.
    if (formData.password !== formData.passwordCheck) {
      // 비밀번호 확인이 일치하지 않으면 에러 메시지를 설정합니다.
      setPasswordErrors({ passwordCheck: '비밀번호가 일치하지 않습니다.' });

      passwordCheckInputIcon.classList.add('checkIconError');
      passwordCheckInputIcon.classList.remove('checkIconNone');
      passwordCheckInputIcon.classList.remove('checkIconOK');

      passwordCheckInputBorder.classList.add('input-error');
      passwordCheckInputBorder.classList.remove('input-green');

    } else {
      // 비밀번호 확인이 일치하면 에러 메시지를 제거합니다.
      setPasswordErrors({ ...passwordErrors, passwordCheck: '' });
      setPasswordFocus(false);
      
      //공백일 때
      passwordCheckInputIcon.classList.add('checkIconNone');
      passwordCheckInputIcon.classList.remove('checkIconError');
      passwordCheckInputIcon.classList.remove('checkIconOK');

      passwordCheckInputBorder.classList.remove('input-green');
      passwordCheckInputBorder.classList.remove('input-error');
      
      if (formData.password !== '' && formData.passwordCheck !== '' && formData.password !== undefined && formData.passwordCheck !== undefined) {
        passwordCheckInputIcon.classList.add('checkIconOK');
        passwordCheckInputIcon.classList.remove('checkIconError');
        passwordCheckInputIcon.classList.remove('checkIconNone');

        passwordCheckInputBorder.classList.add('input-green');
        passwordCheckInputBorder.classList.remove('input-error');
      }
    }
  }

const updateUser = async (e) => {
    e.preventDefault();

    if(passwordErrors.passwordCheck){

      alert("비밀번호 입력을 확인해주세요");
      return

    } else {
        const fields = ["email", "password", "name", "cellphone", "role"];
        const formElements = e.target.elements;

        const formValues = fields
        .map((field) => ({
          [field]: formElements.namedItem(field).value
        }))
        .reduce((current, next) => ({ ...current, ...next }));
        
        // 전화번호 formatting 해제
        const replacePhoneNumber = formValues["cellphone"].replaceAll('-','');
        const updatedFormValues = { ...formValues, cellphone: replacePhoneNumber };

        let registerRequest;

        try {
          registerRequest = await axios.post(
            `/profile/updateUser`,
            {
              ...updatedFormValues
            },
            { baseURL : process.env.REACT_APP_SERVER_URL },
            {
              withCredentials: true
            }
          );
        } catch ({ response }) {
          registerRequest = response;
        }
        const { data: registerRequestData } = registerRequest;

        const messages = registerRequestData.messages;

        if ( registerRequestData.success ) {

          // 성공 메세지 표출
          if (messages && messages.success) {
            alert(messages.success);
          }
          return navigate("/");

        } else {
          // 실패 메세지 표출
          if (messages && messages.errors) {

            /*
            //메세지 alert을 위한 문자 만들기
            const errors = messages.errors;
            
            const getErrorMessages = (errors) => {
              const errorMessages = Object.values(errors);
              return errorMessages.join('\n');
            };
        
            const errorMessage = getErrorMessages(errors);
            */

            setErrorMessage({ message: messages.errors });

            // 오류 필드에 포커스 설정
            if(messages.errors && messages.errors.name) {
              setFullNameFocus(true);
            }

            if(messages.errors && messages.errors.cellphone) {
              setCellPhoneFocus(true);
            }

            if(messages.errors && messages.errors.email) {
              setEmailFocus(true);
            }

            if(messages.errors && messages.errors.password) {
              setPasswordFocus(true);
            }
          }

          if (messages && messages.databaseError) {
            setErrorMessage({ message: messages.databaseError });
            setEmailFocus(true);
          }
          
        }
    }
  };

  const logout = async (e) => {
    e.preventDefault();
    let logoutRequest;

    try {
      logoutRequest = await axios.post( 
        `/logout`,
        { baseURL : process.env.REACT_APP_SERVER_URL },
        {
          withCredentials : true
        });

      //console.log("logout Result : "+ JSON.stringify(logoutRequest));

      if(logoutRequest) {
        const { data : logoutRequestData } = logoutRequest;
      
        //console.log(logoutRequestData.success);
    
        if ( logoutRequestData.success ) {
          alert("로그아웃이 완료되었습니다");
          // 성공 후 메인페이지로 이동
          return navigate("/");
        }
      }

    } catch ({ error }) {

      console.log("로그아웃 실패 : " + error)
    }
  };

  const deleteUser = async (e) => {
    e.preventDefault();

    if(window.confirm("회원 탈퇴 시 가입 관련 정보가 모두 즉시 삭제되며, 복구할 수 없습니다\n계속 진행하시겠습니까?")){

      let deleteRequest;

      try {
        deleteRequest = await axios.get(
          `/profile/deleteUser?id=${userId}`,
          { baseURL : process.env.REACT_APP_SERVER_URL },
          {
            withCredentials: true
          });
      } catch ({ response }) {
        deleteRequest = response;
      }
      const { data: deleteRequestData } = deleteRequest;

      const messages = deleteRequestData.messages;

      if ( deleteRequestData.success ) {

        // 성공 메세지 표출
        if (messages && messages.success) {
          alert(messages.success);
        }
        return navigate("/");

      } else {
        // 실패 메세지 표출
        if (messages && messages.errors) {
          const errors = messages.errors;

          alert(errors.databaseError);
        }
      }
    } else {
      return
    }
  };

  const followCursor = (e) => {
    let posX = e.clientX - window.innerWidth / 2;
    let posY = e.clientY - window.innerWidth / 6;
    setSquares1to6(
      "perspective(500px) rotateY(" +
        posX * 0.05 +
        "deg) rotateX(" +
        posY * -0.05 +
        "deg)"
    );
    setSquares7and8(
      "perspective(500px) rotateY(" +
        posX * 0.02 +
        "deg) rotateX(" +
        posY * -0.02 +
        "deg)"
    );
  };
  return (
    <>
      <Navbar />
      <div className="wrapper register-page">
        <div className="page-header">
          <div className="page-header-image" />
          <div className="content" id="profileContent">
            <Container>
              <Row>
                <Col className="login-card">
                  <Card className="card-register">
                    <CardHeader>
                      <CardTitle tag="h4">Profile</CardTitle>
                    </CardHeader>
                      <Form className="form" onSubmit={updateUser}>
                      {isLoading ? (
                        // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                        <div className="loader" style={{height:'70%'}}>
                          <div className="loader-container" style={{marginTop:'-30px'}}>
                            <p className='loader-title'>Loading...</p>
                          </div>
                        </div>
                      ) : (<></>)}
                        <CardBody>
                            <InputGroup>
                              <InputGroupText>
                                <FontAwesomeIcon icon={faEnvelope} />
                              </InputGroupText>
                              <Input
                                placeholder="Email(ID)"
                                type="email"
                                name="email"
                                value={formData.email}
                                required
                                disabled
                                className={classnames({
                                  "input-focus": emailFocus,
                                })}
                              />
                            </InputGroup>

                          <InputGroup>
                              <InputGroupText>
                                <FontAwesomeIcon icon={faUser} />
                              </InputGroupText>
                              <Input
                                placeholder="Name"
                                type="text"
                                name="name"
                                value={formData.name}
                                required
                                onChange= {handleInputChange}
                                onFocus={(e) => setFullNameFocus(true)}
                                onBlur={(e) => setFullNameFocus(false)}
                                className={classnames({
                                  "input-focus": fullNameFocus,
                                })}
                              />
                            </InputGroup>

                            {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessage.message.name}</div>
                            )}

                            <InputGroup>
                              <InputGroupText>
                                <FontAwesomeIcon icon={faMobileScreen} />
                              </InputGroupText>
                              <Input
                                placeholder="Phone(선택입력사항)"
                                type="text"
                                name="cellphone"
                                value={formData.cellphone}
                                onChange= {handleInputChange}
                                onFocus={(e) => setCellPhoneFocus(true)}
                                onBlur={(e) => setCellPhoneFocus(false)}
                                
                                className={classnames({
                                  "input-focus": cellPhoneFocus,
                                })}
                              />
                            </InputGroup>

                            {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessage.message.cellphone}</div>
                            )}

                            <InputGroup>
                              <InputGroupText>
                                <FontAwesomeIcon icon={faKey} />
                              </InputGroupText>
                              <Input
                                placeholder="Password"
                                type="password"
                                name="password"
                                value={formData.password}
                                required
                                onChange= {handleInputChange}
                                onKeyUp= {validatePassword}
                                onBlur= {validatePassword} 
                                
                                className={classnames({
                                  "input-focus": passwordFocus,
                                })}
                              />
                            </InputGroup>
                            
                            <InputGroup id="passwordCheckBorder">
                              <InputGroupText id="passwordCheckIcon" className="checkNone">
                                <FontAwesomeIcon icon={faCheck} />
                              </InputGroupText>
                              <Input
                                placeholder="Password Check"
                                type="password"
                                id="passwordCheck"
                                name="passwordCheck"
                                required
                                onChange= {handleInputChange}
                                onKeyUp= {validatePassword}
                                onBlur={validatePassword}
                              />
                            </InputGroup>
                            {passwordErrors.passwordCheck && (
                              <div className="errorMessage" style={{ color: 'red' }}>{passwordErrors.passwordCheck}</div>
                            )}

                            {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessage.message.password}</div>
                            )}

                            <InputGroup>
                              <Input
                                style={{display:'none'}}
                                type="text"
                                name="role"
                                value={formData.role}
                              />
                            </InputGroup>
                            {/* 
                            {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red' }}>{errorMessage.message}</div>
                            )} */}
                            {/*
                            {roleCheck && roleCheck === "admin" ? (
                              <div style={{display:'inline-block', width:'100%', textAlign: 'center', marginBottom:'-20px'}}>
                                <Button href="/ServerState" className="form-button"
                                  style={{width:'80%'}}
                                >Docker Container</Button>
                              </div>
                            ):(<></>)}
                            */}
                        </CardBody>
                        <CardFooter className="register-footer">
                          <Button type="submit" className="itsBtnDefault" size="md">
                            변경사항 저장
                          </Button>
                          <Button type="button" className="itsBtnGray" size="md" onClick={logout}>
                            로그아웃
                          </Button>
                              <br/>
                          <a href="/">
                            <Button type="button" className="sideLink" onClick={deleteUser}>
                              회원탈퇴
                            </Button>
                          </a>
                        </CardFooter>
                      </Form>
                  </Card>
                </Col>
              </Row>
              <div
                className="square square-7"
                id="square7"
                style={{ transform: squares7and8 }}
              />
              <div
                className="square square-8"
                id="square8"
                style={{ transform: squares7and8 }}
              />
              <div
                className="square square-1"
                id="square1"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-2"
                id="square2"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-3"
                id="square3"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-4"
                id="square4"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-5"
                id="square5"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-6"
                id="square6"
                style={{ transform: squares1to6 }}
              />
            </Container>
          </div>
        </div>
      </div>
    </>
  );
}